import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import PPIService from "../../services/PPIService";
import PaymentLimit from "./PaymentLimit";

const PaymentLimitGroup = () => {
  const [loading, setLoading] = useState(false);

  const [limits, setLimits] = useState({
    transactionCountMonth: 0,
    transactionAmountMonth: 100000,
    transactionCountDay: 0,
    transactionAmountDay: 10000,
  });

  const config = [
    {
      key: "transactionCountMonth",
      label: "Transaction Count Per Month",
      min: 0,
      max: 1200,
    },
    {
      key: "transactionAmountMonth",
      label: "Transaction Amount Per Month",
      min: 1,
      max: 100000,
    },
    {
      key: "transactionCountDay",
      label: "Transaction Count Per Day",
      min: 0,
      max: 50,
    },
    {
      key: "transactionAmountDay",
      label: "Transaction Amount Per Day",
      min: 1,
      max: 10000,
    },
  ];

  const handleChange = (key, value) => {
    setLimits((prev) => ({ ...prev, [key]: value }));
  };

  useEffect(() => {
    fetchPPILimit();
  }, []);

  const fetchPPILimit = async () => {
    setLoading(true);
    try {
      const result = await PPIService.getPPILimit();
      if (!result.success) {
        Swal.fire("Oops!", result.message || "Failed to fetch limits", "error");
        return;
      }

      const responseData = result.data;

      if (responseData.status === "SUCCESS") {
        const data = responseData.data;

        setLimits({
          transactionCountMonth: data.monthly_limit_count || 0,
          transactionAmountMonth: data.monthly_limit_amount || 0,
          transactionCountDay: data.daily_limit_count || 0,
          transactionAmountDay: data.daily_limit_amount || 0,
        });
      } else {
        Swal.fire("Oops!", responseData.message, "error");
      }
    } catch (error) {
      Swal.fire(
        "Oops!",
        error.response?.data?.message || error.message || "Request Failed",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  const ppiLimitUpdateHandler = async () => {
    const {
      transactionCountDay,
      transactionAmountDay,
      transactionCountMonth,
      transactionAmountMonth,
    } = limits;

    setLoading(true);
    try {
      const result = await PPIService.updatePPILimit(
        transactionCountDay,
        transactionAmountDay,
        transactionCountMonth,
        transactionAmountMonth
      );

      if (!result.success) {
        Swal.fire(
          "Oops!",
          result.message || "Failed to update limits",
          "error"
        );
        return;
      }

      const responseData = result.data;

      if (responseData.status === "SUCCESS") {
        Swal.fire("Success!", responseData.message, "success");
        fetchPPILimit(); // Optionally refetch after update
      } else {
        Swal.fire("Oops!", responseData.message, "error");
      }
    } catch (error) {
      Swal.fire(
        "Oops!",
        error.response?.data?.message || error.message || "Request Failed",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      {config.map(({ key, label, min, max }) => (
        <PaymentLimit
          key={key}
          label={label}
          min={min}
          max={max}
          value={limits[key]}
          onChange={(value) => handleChange(key, value)}
        />
      ))}

      <div className="text-end mt-3">
        <button
          className="btn btn-primary btn-md w-100"
          onClick={ppiLimitUpdateHandler}
          disabled={loading}
        >
          {loading ? "Updating..." : "Update"}
        </button>
      </div>
    </div>
  );
};

export default PaymentLimitGroup;
